import { createContext, useContext } from 'react';

import { Store, createStore } from '../../../../core/store/store.js';
import type { MeterBarChartTooltipState } from '../types/state.js';

export const MeterBarChartTooltipContext = createContext<
  Store<MeterBarChartTooltipState>
>(createStore({} as MeterBarChartTooltipState));

export const useMeterBarChartTooltipContext = () =>
  useContext(MeterBarChartTooltipContext);
